import { Component } from '@angular/core';
import { TranslationManager } from 'src/common';

@Component({
    selector: 'unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls:['./unauthorized.component.scss']
})

export class UnauthorizedComponent{
  translationManager = TranslationManager;
}
